import { Component, OnInit } from '@angular/core';
import { KpiFilters } from '../../models/kpi-filters.model';

@Component({
  selector: 'app-kpi-dashboard',
  templateUrl: './kpi-dashboard.component.html',
  styleUrl: './kpi-dashboard.component.scss',
  standalone: false,
})
export class KpiDashboardComponent {
  filters: KpiFilters = {};

  onFiltersChanged(filters: KpiFilters): void {
    this.filters = { ...filters };
  }
}
